import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewDefineComponent } from './view-define.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import {
	MatFormFieldModule,
	MatInputModule,
	MatButtonModule,
	MatCheckboxModule,
	MatSelectModule,
	MatRadioModule,
	MatIconModule,
	MatTableModule
} from '@angular/material';

@NgModule({
	declarations: [ViewDefineComponent],
	imports: [
		CommonModule,
		DragDropModule,
		MatFormFieldModule,
		MatInputModule,
		MatButtonModule,
		MatCheckboxModule,
		MatSelectModule,
		MatRadioModule,
		MatIconModule,
		MatTableModule
	],
	exports: [ViewDefineComponent]
})
export class ViewDefineModule {}
